import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { MACRO_MEDIA_BASE } from '../../_shared/data/media';
import { ICONS } from '../../_shared/icons';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildAutoFitText } from '../../_shared/text/autofit-text';
import { PAYMENT_METHOD_RULES } from '../../_shared/data/payment-text-rules';
import { buildBackgroundImage } from '../../_shared/images/background-image';

export const macroCuotas1080x1920: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),

    // Shape blanca
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/macro-cuotas/shape.svg`,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 970,
      targetWidth: 915,
      targetHeight: 1780
    },

    // Logo Macro
    {
      cropX: 0,
      cropY: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 650.4157,
      top: 361.5661,
      width: 8930,
      height: 3545,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0383,
      scaleY: 0.0383,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: ICONS.icono.src,
      crossOrigin: null,
      filters: []
    },

    buildPillPair({
      left: { pieceId: 'event', text: 'CALAMARO', style: 'white-blue-stroke' },
      right: { pieceId: 'location', text: 'Rosario', style: 'white-pink-text' },
      fontSize: 32,
      paddingX: 70,
      paddingY: 10,
      strokeWidth: 1.824,
      position: { left: 540, top: 585, width: 632.4051, height: 54.7686 }
    }),

    buildDiscountValue({
      pieceId: 'payment-value',
      text: '6',
      fontSize: 530,
      position: { left: 460, top: 940, width: 641.7024, height: 610.2 }
    }),
    buildAutoFitText({
      pieceId: 'payment-text',
      text: 'cuotas sin interés',
      fontSize: 64,
      fill: '#0030eb',
      fontWeight: 'bold',
      lineHeight: 0.96,
      textAlign: 'left',
      originY: 'center',
      locked: false,
      minFontSize: 64,
      autoFitMaxHeight: 130,
      autoFitMaxWidth: 200,
      textStyleRules: PAYMENT_METHOD_RULES,
      position: { left: 731.3398, top: 906.6275, width: 521.3817, height: 108.5252 }
    }),

    buildAutoFitText({
      pieceId: 'payment-method-text',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 62,
      fill: '#0030eb',
      lineHeight: 0.96,
      textAlign: 'center',
      originY: 'center',
      locked: false,
      minFontSize: 62,
      autoFitMaxHeight: 130,
      autoFitMaxWidth: 665,
      textStyleRules: PAYMENT_METHOD_RULES,
      position: { left: 540, top: 1274.4008, width: 624.3974, height: 147.126 }
    }),

    buildAutoFitText({
      pieceId: 'secondary-text',
      text: 'Venta General: 18/6 a las 12hs',
      fontSize: 28,
      fontWeight: 'bold',
      fill: '#0030eb',
      lineHeight: 0.96,
      textAlign: 'center',
      originY: 'center',
      locked: false,
      minFontSize: 28,
      autoFitMaxHeight: 130,
      autoFitMaxWidth: 665,
      // textStyleRules: PAYMENT_METHOD_RULES,
      position: { left: 540, top: 1425.9466, width: 665, height: 31.64 }
    }),

    buildAutoFitText({
      pieceId: 'footer-text',
      text: 'CARTERA CONSUMO. CFTNA 0,00%',
      fontSize: 22,
      fontWeight: 'bold',
      minFontSize: 22,
      fill: '#000000',
      autoFitMaxHeight: 75,
      position: { left: 540, top: 1647.3843, width: 665, height: 31.64 }
    })
  ],
  background: 'transparent'
};
